import { create } from "zustand";
import { useFetchDayWiseCustomerPOBReport } from "../slices/DailyPOBReportSlices/fetchDayWiseCustomerPOBReport";
import { useFetchTypeWiseCountPOBSummary } from "../slices/DailyPOBReportSlices/fetchTypeWiseCountPOBSummary";
import { useFetchMonthlyPOBOrdersData } from "../slices/DailyPOBReportSlices/fetchMonthlyPOBOrdersSlice";

interface DailyPOBReportInterface
  extends ReturnType<typeof useFetchDayWiseCustomerPOBReport>,
    ReturnType<typeof useFetchTypeWiseCountPOBSummary>,
    ReturnType<typeof useFetchMonthlyPOBOrdersData> {}

export const DailyPOBReportStore = create<DailyPOBReportInterface>((...a) => ({
  ...useFetchDayWiseCustomerPOBReport(...a),
  ...useFetchTypeWiseCountPOBSummary(...a),
  ...useFetchMonthlyPOBOrdersData(...a),
}));
